import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MultiSectionDigitalClock } from '@mui/x-date-pickers/MultiSectionDigitalClock';
export default function TimePicker(props) {
    return (_jsx(LocalizationProvider, { dateAdapter: AdapterDayjs, children: _jsx(DemoContainer, { components: [
                'MultiSectionDigitalClock',
            ], children: _jsx(DemoItem, { label: 'TimePicker', children: _jsx(MultiSectionDigitalClock, { ampm: false }) }) }) }));
}
